<div class="col-md-12 clear-all content-wrapper"
  [ngClass]="{'margin-top-50':userInputDetail['showIcon'],
  'margin-top-right-0':userInputDetail['showIcon'] && router.url === '/quote/your-product-options' && selectedProductCode === 'C',
  'margin-50':!userInputDetail['showIcon'],
  'padding-margin-pc-c': selectedProductCode && 
  selectedProductCode==='C' && userInputDetail['label']==='Done editing',
  'margin-0-50': !userInputDetail['showIcon'] && 
  selectedProductCode === 'C' && router.url === '/quote/your-product-options', 
  'margin-top-clear': selectedProductCode && 
  (selectedProductCode === 'H' || selectedProductCode === 'G') 
  && router.url === '/quote/your-product-options'}">


  @if (!((router.url === '/ho-underwriting/medical-conditions' ||
    router.url === '/home/medical-conditions' ||
    router.url === '/home/dependant-medical-conditions' ||
    router.url === '/ho-underwriting/dependant-medical-conditions') && !checkData)) {
    <div class="col-md-12 text-right padding-right-0 ">
      <div class="bottom-container">
        <app-button (click)="goNextPage()" id="bottom-nav-cta-left" class="float-right padding-rl-2" name="bottom-nav-cta-left"
          [isDisabled]="disabled" [parent]="userForm" [buttonType]="buttonType" [controllerData]="userInputDetail">
        </app-button>
      </div>
    </div>
  }
  @if ((router.url === '/ho-underwriting/medical-conditions'
    || router.url === '/home/medical-conditions' ||
    router.url === '/home/dependant-medical-conditions' ||
    router.url === '/ho-underwriting/dependant-medical-conditions') && !checkData) {
    <div class=" col-md-12 text-right padding-right-0">
      @if (!editMode) {
        <button class="btn btn-secondary btn-chevron fixBtn" id="bottom-nav-skip"
        (click)="navToDependant()">Skip</button>
      }
      @if (editMode) {
        <app-button (click)="goNextPage()" id="bottom-nav-cta-left" class="float-right" name="bottom-nav-cta-left"
          [isDisabled]="disabled" [parent]="userForm" [buttonType]="buttonType" [controllerData]="userInputDetail">
        </app-button>
      }
    </div>
  }
  @if (router.url === '/home/before-you-start') {
    <div id="bottom-nav-cta-right" name="bottom-nav-cta-right"
      class="col-md-12 text-right btn-msg btn-msg-responsive ">
      <small id="text-bottom-nav">{{contentData.contentBottomNavigationBar.approxQuotationTime}}</small>
    </div>
  }
</div>
@if (isLocked) {
  <app-modal [modalConfig]="lockedAlertModalConfig" (closeModal)="closeLockedModal()" (primaryBtnClick)="closeLockedModal()"
    [saveDataFlag]="false">
  </app-modal>
}